import { useContext } from 'react';

import { isDefined } from '@hsp/utilities';

import { CategoryContext } from 'pages/audience/shared/context';

export const useCategory = () => {
  const context = useContext(CategoryContext);

  if (!isDefined(context)) {
    throw new Error('useCategory must be used within a CategoryProvider');
  }

  return context;
};
